export enum UserRoleEnum {
    SuperAdmin = 'SuperAdmin',
    CompanyAdmin = 'Admin',
    Student = 'Student'
}
